import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} MewsEngineProps
 */

/**
 * MewsEngine MewsEngine.
 * @augments {Base<MewsEngineProps>}
 */
export default class MewsEngine extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'MewsEngine',
    options: {
      configurationId: {
        value: '',
        type: String,
      },
      hotelId: {
        value: '',
        type: String,
      },
      adults: {
        value: 0,
        type: Number,
      },
      kids: {
        value: 0,
        type: Number,
      },
      from: {
        value: '',
        type: String,
      },
      to: {
        value: '',
        type: String,
      },
      voucher: {
        value: '',
        type: String,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this._onClick = (e) => {
      e.preventDefault();
      const voucherInput = document.querySelector('[name="voucher"]');
      const voucherValue = voucherInput?.value || this.$options.voucher;

      const url = new URL(`https://app.mews.com/distributor/${this.$options.configurationId}`);
      if (this.$options.from) url.searchParams.set('mewsStart', this.$options.from);
      if (this.$options.to) url.searchParams.set('mewsEnd', this.$options.to);
      if (this.$options.adults) url.searchParams.set('mewsAdultCount', this.$options.adults);
      if (this.$options.kids) url.searchParams.set('mewsChildCount', this.$options.kids);
      if (voucherValue) url.searchParams.set('mewsVoucherCode', voucherValue);
      if (this.$options.hotelId) url.searchParams.set('mewsRoom', this.$options.hotelId);
      url.searchParams.set('mewsRoute', 'rates');

      window.open(url.toString(), '_blank');
    };

    this.$el.addEventListener('click', this._onClick);
  }

  /**
   *
   */
  destroyed() {
    if (this._onClick) {
      this.$el.removeEventListener('click', this._onClick);
    }
  }
}
